// extracted by mini-css-extract-plugin
module.exports = {"title":"Task_title__TnMK8","tooltip":"Task_tooltip__3-V4R"};